import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PagesComponent } from './pages.component';
import { AuthGuard } from '../auth/auth.guard';
import { MangeUnitsComponent } from './units/mange-units/mange-units.component';
import { UnitDetailsComponent } from './units/unit-details/unit-details.component';
import { AddClientComponent } from './units/add-client/add-client.component';
import { DashbaordComponent } from './main-dashboard/dashbaord/dashbaord.component';
import { LiveGateTypeComponent } from './main-dashboard/live-gate-type/live-gate-type.component';
import { MangeVillageComponent } from './villages/mange-village/mange-village.component';
import { VillageDetailsComponent } from './villages/village-details/village-details.component';
import { MainComponent } from './genral-access/main/main.component';
import { OpreatorsMainComponent } from './operators/opreators-main/opreators-main.component';
import { RolesMainComponent } from './roles/roles-main/roles-main.component';
import { MainGatesComponent } from './gates/main-gates/main-gates.component';
import { AllClientsComponent } from './clients/all-clients/all-clients.component';
import { ClientsLogComponent } from './clients/clients-log/clients-log.component';
import { ClientsPaymentComponent } from './clients/clients-payment/clients-payment.component';
import { AllServicesComponent } from './mange-service/all-services/all-services.component';
import { EditClientComponent } from './units/edit-client/edit-client.component';
import { ViewClientComponent } from './units/view-client/view-client.component';
import { MainLogsComponent } from './all-logs/main-logs/main-logs.component';
import { MainSerReqComponent } from './service-request/main-ser-req/main-ser-req.component';
import { ServDetailsComponent } from './service-request/serv-details/serv-details.component';
import { AllUtiltesComponent } from './utilty/all-utiltes/all-utiltes.component';
import { SystemDashboardComponent } from './main-dashboard/system-dashboard/system-dashboard.component';
import { MainFamilyComponent } from './family/main-family/main-family.component';
import { UserInfoComponent } from './family/user-info/user-info.component';
import { LogsClientComponent } from './units/logs-client/logs-client.component';
import { UnitInoviceComponent } from './units/unit-inovice/unit-inovice.component';

const routes: Routes = [

  {
    path : "pages",
    canActivate: [AuthGuard],
    component : PagesComponent,
    children : [
      { path: '', redirectTo : "Dashboard", pathMatch : "full"},
      { path: 'Dashboard', component: LiveGateTypeComponent},
      { path: 'system_dashboard', component: SystemDashboardComponent},
      { path: 'gate_types/:id', component: DashbaordComponent },
      // { path: 'mange_units', component: MangeUnitsComponent },
      {
        path: "mange_units",
        component: MangeUnitsComponent,
        canActivate: [AuthGuard],
        loadChildren: () => import('./units/units.module').then(m => m.UnitsModule)
      },
      {
        path: "unit_details/:id",
        component: UnitDetailsComponent,
        canActivate: [AuthGuard],
        loadChildren: () => import('./units/units.module').then(m => m.UnitsModule)
      },
      // { path: 'unit_details/:id', component: UnitDetailsComponent },
      { path: 'add_client/:id', component: AddClientComponent },
      { path: 'edit_client/:id/:id1', component: EditClientComponent },
      { path: 'view_client/:id/:id1', component: ViewClientComponent },
      { path: 'mange_village', component: MangeVillageComponent },
      { path: 'village_details/:id', component: VillageDetailsComponent },
      { path: 'genral_accsess', component: MainComponent },
      { path: 'Operators', component: OpreatorsMainComponent },
      { path: 'all_logs', component: MainLogsComponent },
      { path: 'roles', component: RolesMainComponent },
      { path: 'mange_gate', component: MainGatesComponent },
      { path: 'clients_payment', component: ClientsPaymentComponent },
      { path: 'all_clients', component: AllClientsComponent },
      { path: 'clients_log', component: ClientsLogComponent },
      { path: 'all_services', component: AllServicesComponent },
      { path: 'service_request', component: MainSerReqComponent },
      { path: 'service_request_Details', component: ServDetailsComponent },
      { path: 'Utility', component: AllUtiltesComponent },
      { path: 'family_requests', component: MainFamilyComponent },
      { path: 'family_user_info/:id', component: UserInfoComponent },
      { path: 'activty_logs/:id', component: LogsClientComponent },
      { path: 'unit_invoice/:id/:name', component: UnitInoviceComponent },
    ]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
